import React from "react"
import { Button, Modal } from "@/shared/ui"
import { listRepairJobs, type RepairJob, fetchRepairCounts, cancelRepair, cancelAllRepairJobs } from "@/modules/crypto-assets/services/repairService"

type Props = { open: boolean; onOpenChange: (v: boolean) => void }

export default function RepairJobsModal({ open, onOpenChange }: Props) {
  const [loading, setLoading] = React.useState(false)
  const [jobs, setJobs] = React.useState<Array<RepairJob & { counts?: { total: number; pending: number; enqueued: number; done: number; failed: number } }>>([])
  const [refreshAt, setRefreshAt] = React.useState(0)

  async function load() {
    setLoading(true)
    try {
      const list = await listRepairJobs(80)
      const withCounts = await Promise.all(list.map(async j => ({
        ...j,
        counts: await fetchRepairCounts(j.id).catch(() => undefined as any)
      })))
      setJobs(withCounts)
      setRefreshAt(Date.now())
    } finally { setLoading(false) }
  }

  React.useEffect(() => { if (open) load() }, [open])

  async function onCancelOne(id: string) {
    try {
      await cancelRepair(id)
      await load()
    } catch {}
  }
  async function onCancelAll() {
    try { await cancelAllRepairJobs(); await load() } catch {}
  }

  return (
    <Modal open={open} onOpenChange={onOpenChange} className="p-4 sm:p-6" style={{ width: 900, maxWidth: 900 }}>
      <div className="mb-3 flex items-center justify-between">
        <div className="text-lg font-semibold">Fila de reparos</div>
        <div className="flex items-center gap-2">
          <Button variant="outline" onClick={load} disabled={loading}>Atualizar</Button>
          <Button variant="destructive" onClick={onCancelAll} disabled={loading}>Cancelar todos</Button>
        </div>
      </div>
      <div className="mb-2 text-xs text-foreground/60">Atualizado {new Date(refreshAt).toLocaleTimeString()}</div>
      <div className="max-h-[70vh] overflow-auto rounded-md border border-border/50">
        <table className="w-full text-sm">
          <thead className="sticky top-0 bg-background">
            <tr className="text-left">
              <th className="p-2">Job</th>
              <th className="p-2">Status</th>
              <th className="p-2">Criado</th>
              <th className="p-2">Progresso</th>
              <th className="p-2">Ações</th>
            </tr>
          </thead>
          <tbody>
            {jobs.map(j => {
              const c = j.counts
              const pct = c && c.total ? Math.round(((c.done) / c.total) * 100) : 0
              const bar = (
                <div className="w-[220px]">
                  <div className="h-2 w-full rounded bg-foreground/10">
                    <div className="h-2 rounded bg-emerald-500" style={{ width: `${pct}%` }} />
                  </div>
                  <div className="mt-1 text-[11px] text-foreground/60">{c ? `${c.done}/${c.total} • pend ${c.pending} • fila ${c.enqueued} • falha ${c.failed}` : '-'}</div>
                </div>
              )
              return (
                <tr key={j.id} className="border-t border-border/50">
                  <td className="p-2 font-mono text-[12px]">{j.id}</td>
                  <td className="p-2">{String(j.status)}</td>
                  <td className="p-2">{new Date(j.created_at).toLocaleString()}</td>
                  <td className="p-2">{bar}</td>
                  <td className="p-2">
                    {String(j.status) === 'running' || String(j.status) === 'pending' ? (
                      <Button variant="outline" className="px-2 py-1 text-xs" onClick={()=> onCancelOne(j.id)}>Cancelar</Button>
                    ) : (
                      <span className="text-foreground/60">-</span>
                    )}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
      <div className="mt-4 flex items-center justify-end">
        <Button variant="ghost" onClick={()=> onOpenChange(false)}>Fechar</Button>
      </div>
    </Modal>
  )
}



